import { render, staticRenderFns } from "./DashBox.vue?vue&type=template&id=3453752b&"
import script from "./DashBox.vue?vue&type=script&lang=js&"
export * from "./DashBox.vue?vue&type=script&lang=js&"
import style0 from "./DashBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports